import { render, staticRenderFns } from "./noRateProduct.vue?vue&type=template&id=94cfb310&scoped=true"
import script from "./noRateProduct.vue?vue&type=script&lang=js"
export * from "./noRateProduct.vue?vue&type=script&lang=js"
import style0 from "./noRateProduct.vue?vue&type=style&index=0&id=94cfb310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cfb310",
  null
  
)

export default component.exports